
import { Box, Button, Card, CardContent, Icon, TextField, Typography } from '@mui/material';
import React, { useState } from "react";
import Mensagem from "../layout/Mensagem";
import Grid from '@mui/material/Grid2';
import { EsqueciSenhaService } from "../../services/autenticacao/EsqueciSenhaService"
import { useVForm, VForm } from '../../forms';
import { DialogMensagem, IDadosModal } from '../modal/DialogMensagem';
import { UtilidadeService } from '../../services/api/utilidades/UtilidadesService';
import logo from "../../../img/fantasygm_logo.png";

type Props = {

    handleChange: any
};

export const EsqueciSenha: React.FC<Props> = ({ handleChange }) => {
    const { formRef } = useVForm();
    const [errorES, setErrorES] = useState(false)
    const [isLoading, setIsLoading] = useState(false)
    const [email, setEmail] = useState("")
    const [codigo, setCodigo] = useState("")
    const [novaSenha, setNovaSenha] = useState("")
    const [confirmarNovaSenha, setConfirmarNovaSenha] = useState("")
    const [messageErrorEmail, setMessageErrorEmail] = useState<string>("")
    const [messageErrorCodigo, setMessageErrorCodigo] = useState<string>("")
    const [messageErrorSenha, setMessageErrorSenha] = useState<string>("")
    const [tituloEsquciSenha, setTituloEsquciSenha] = useState<string>("Informe o seu e-mail cadastrado.")
    const [showModalMensagem, setShowModalMensagem] = useState(false);
    const [dadosModal, setDadosModal] = useState<IDadosModal>({
        acao: false,
        label: "",
        tipo: "error",
        mensagem: "Sessão Expirada!",
        display: "none",
        titulo: "Atenção"
    });

    let count = 1;

    const [display, setdisplay] = useState({
        textEmail: true,
        btnEmail: true,
        textCodigo: false,
        btnCodigo: false,
        textNovaSenha: false,
        textConfirmarNovaSenha: false,
        btnNovaSenha: false
    });

    const mostrarEnvioCodigo = () => {
        setdisplay({ textEmail: true, btnEmail: true, textCodigo: false, btnCodigo: false, textNovaSenha: false, textConfirmarNovaSenha: false, btnNovaSenha: false });

    };

    const mostrarValidacaoCodigo = () => {
        setdisplay({ textEmail: false, btnEmail: false, textCodigo: true, btnCodigo: true, textNovaSenha: false, textConfirmarNovaSenha: false, btnNovaSenha: false });
        setTituloEsquciSenha("Validação do código enviado.")
    };

    const mostrarNovaSenha = () => {
        setdisplay({ textEmail: false, btnEmail: false, textCodigo: false, btnCodigo: false, textNovaSenha: true, textConfirmarNovaSenha: true, btnNovaSenha: true });
        setTituloEsquciSenha("Nova senha.")
    };

    const handleSubmitEnviarCodigo = async (e: any) => {
        setIsLoading(true);
        setErrorES(false);

        if (email.length <= 0) {
            setIsLoading(false);
            setErrorES(true);
            setMessageErrorEmail('Preencha o campo email');
            return;
        }

        e.preventDefault();
        const fetchData = async () => {
            await EsqueciSenhaService.recuperarSenha(email)
                .then((result) => {
                    if (result.dado) {
                        setErrorES(false);
                        mostrarValidacaoCodigo();
                        setShowModalMensagem(true);
                        setDadosModal({
                            acao: true,
                            label: "",
                            tipo: "success",
                            mensagem: "Código enviado com sucesso para sua caixa de email!",
                            display: "none",
                            titulo: "Atenção"
                        });
                    }
                    else {
                        setErrorES(true);
                        setMessageErrorEmail("E-mail não cadastrado!");
                    }
                }).catch((errors) => {
                    setIsLoading(false);
                    if (!errors.response.data.processado) {
                        setMessageErrorEmail(errors.response.data.mensagem.replace("Inconsistência: ", ""));
                    } else {
                        setMessageErrorEmail("E-mail inválido!")
                    }
                });
            setIsLoading(false);;
            setIsLoading(false);
        }
        fetchData();
    }

    const handleSubmitValidarCodigo = async (e: any) => {
        e.preventDefault();
        setIsLoading(true);

        if (codigo.length !== 6) {
            setIsLoading(false);
            setErrorES(true);
            setMessageErrorCodigo('O código deve 6 possuir 6 caracteres!');
            return;
        }

        const fetchData = async () => {
            await EsqueciSenhaService.validarCodigo(codigo)
                .then((result) => {
                    if (result.dado) {
                        setErrorES(false);
                        localStorage.setItem("@tokenTrocaSenha", result.dado);
                        mostrarNovaSenha();
                        setShowModalMensagem(true);
                        setDadosModal({
                            acao: true,
                            label: "",
                            tipo: "success",
                            mensagem: "Código validado com sucesso!",
                            display: "none",
                            titulo: "Atenção"
                        });
                    }
                    else {
                        setErrorES(true);
                        setMessageErrorCodigo("Código inválido!");
                    }

                }).catch((errors) => {
                    setIsLoading(false);
                    setErrorES(true);
                    if (errors.response.data.processado) {
                        setMessageErrorCodigo(errors.response.data.dado);
                    } else {
                        setMessageErrorEmail("Código expirado! Favor solicitar novamente.")
                    }
                });
            setIsLoading(false);
        }
        fetchData();
    }

    const handleSubmitAlterarSenha = async (e: any) => {
        e.preventDefault();
        setIsLoading(true);
        let token = localStorage.getItem("@tokenTrocaSenha") ?? "";
        if (novaSenha.length < 6) {
            setIsLoading(false);
            setErrorES(true);
            setMessageErrorSenha("O campo nova Senha deve conter no minimo 6 caracteres.");
            return;
        }

        if (confirmarNovaSenha.length < 6) {
            setIsLoading(false);
            setErrorES(true);
            setMessageErrorSenha("O campo confirmar nova senha deve conter no minimo 6 caracteres.");
            return;
        }

        if (novaSenha !== confirmarNovaSenha) {
            setIsLoading(false);
            setErrorES(true);
            setMessageErrorSenha("As senhas não conferem!");
            return;
        }

        const fetchData = async () => {
            const resp = await EsqueciSenhaService.alterarSenha(novaSenha, confirmarNovaSenha, token)
                .then((result) => {
                    if (result.dado) {
                        localStorage.removeItem("@tokenTrocaSenha");
                        setShowModalMensagem(true);
                        setDadosModal({
                            acao: true,
                            label: "",
                            tipo: "success",
                            mensagem: "Senha alterada com sucesso!",
                            display: "none",
                            titulo: "Atenção"
                        });
                        setTimeout(() => handleChange("event", 0), 3000);
                    }
                    else {
                        setErrorES(true);
                        setMessageErrorSenha("Algo deu errado durante o envio do código. Tente novamente mais tarde!");
                    }
                }).catch((errors) => {
                    setIsLoading(false);
                    setErrorES(true);
                    if (errors.response.data.processado) {
                        setMessageErrorSenha(errors.response.data.dado);
                    } else {
                        setMessageErrorSenha("Código expirado! Favor solicitar novamente.")
                    }

                });
            setIsLoading(false);
        }
        fetchData();
    }
    const toggleModalMensagem = () => {
        setShowModalMensagem(modalVisivel => !modalVisivel);
    };

    return (
        <Box display="flex" alignItems="center" justifyContent="center" >
            {showModalMensagem && <DialogMensagem dados={dadosModal} isModalVisible={showModalMensagem} onBackClickClose={toggleModalMensagem} />}
            <VForm ref={formRef} onSubmit={handleSubmitAlterarSenha}>
                <Card>
                    <CardContent>
                        <Box display="flex" flexDirection="column" gap={2} width={UtilidadeService.isMobile() ? 250 : 380} >
                            <Grid container size={12} display="flex" alignItems="center" justifyContent="center">
                                <Grid size={12} display="flex" alignItems="center" justifyContent="center" alignSelf={"center"}>
                                    <Typography variant="h6">
                                        <img src={logo} width={175} height={150} alt='logo' />
                                    </Typography>
                                </Grid>
                                <Grid size={12} display="flex" alignItems="center" justifyContent="center" alignSelf={"center"}>
                                    <Icon>lock</Icon>
                                </Grid>
                            </Grid>
                            <Typography variant="h6" align="center" >{tituloEsquciSenha}</Typography>
                            <TextField
                                type="text"
                                name="email"
                                label="E-mail"
                                variant="standard"
                                placeholder='Informe seu email'
                                onChange={(e) => setEmail(e.target.value)}
                                required
                                fullWidth
                                value={email}
                                error={!!errorES}
                                helperText={messageErrorEmail}
                                onKeyDown={() => { errorES && setErrorES(false); setMessageErrorEmail(""); }}
                                style={{ display: display.textEmail ? "inline-block" : "none", width: "100%" }}
                                FormHelperTextProps={{ style: { color: "red" } }}

                            />
                            <Grid container direction="row" spacing={2}>
                                <Grid container size={{ xs: 12, sm: 6 }} >
                                    <Button type='submit' color='primary' variant='contained' disabled={!errorES && isLoading}
                                        fullWidth
                                        style={{ display: display.btnEmail ? "inline-block" : "none", width: "100%", marginTop: "20px" }}
                                        onClick={handleSubmitEnviarCodigo}>{isLoading ? "Enviando..." : "Enviar Código"}
                                    </Button>
                                    {
                                        errorES && !isLoading && display.textEmail && display.btnEmail &&
                                        (
                                            <Box display="flex" alignItems="center" justifyContent="center">
                                                <Grid container size={{ xs: 12, sm: 12 }} >
                                                    <Mensagem type="error" msg={messageErrorEmail} other={count++} />
                                                </Grid>
                                            </Box>
                                        )
                                    }
                                </Grid>
                                <Grid size={{ xs: 12, sm: 6 }} >
                                    <Button type='submit' color='primary' variant='contained' disabled={isLoading}
                                        fullWidth style={{ display: display.btnEmail ? "inline-block" : "none", width: "100%", marginTop: "20px" }}
                                        onClick={() => handleChange("event", 0)}
                                    >Voltar</Button>
                                </Grid>
                            </Grid>
                            <TextField required
                                type="text"
                                name="codigo"
                                label="Código"
                                variant="standard"
                                placeholder='Informe seu código de recuperação'
                                fullWidth style={{ display: display.textCodigo ? "inline-block" : "none", width: "100%" }}
                                error={!!errorES}
                                helperText={messageErrorCodigo}
                                onChange={(e) => setCodigo(e.target.value)}
                                onKeyDown={() => { errorES && setErrorES(false); setMessageErrorCodigo(""); }}
                            />
                            <Grid container direction="row" spacing={2}>
                                <Grid container size={{ xs: 12, sm: 6 }} >
                                    <Button type='submit' color='primary' variant='contained' disabled={!errorES && isLoading}
                                        fullWidth
                                        style={{ display: display.btnCodigo ? "inline-block" : "none", marginTop: "20px" }}
                                        onClick={handleSubmitValidarCodigo}>{isLoading ? "Validando..." : "Validar Código"}
                                    </Button>
                                    {
                                        errorES && !isLoading && display.textCodigo && display.btnCodigo &&
                                        (
                                            <Box display="flex" alignItems="center" justifyContent="center">
                                                <Grid container size={{ xs: 12, sm: 12 }} >
                                                    <Mensagem type="error" msg={messageErrorCodigo} other={count++} />
                                                </Grid>
                                            </Box>
                                        )
                                    }
                                </Grid>
                                <Grid size={{ xs: 12, sm: 6 }} >
                                    <Button type='submit' color='primary' variant='contained' disabled={isLoading}
                                        fullWidth
                                        style={{ display: display.btnCodigo ? "inline-block" : "none", marginTop: "20px" }}
                                        onClick={mostrarEnvioCodigo}>
                                        Voltar
                                    </Button>
                                </Grid>
                            </Grid>
                            <TextField required
                                type="password"
                                name="novaSenha"
                                label="Nova Senha"
                                variant="standard"
                                placeholder='Informe sua nova senha.'
                                fullWidth
                                error={!!errorES}
                                onKeyDown={() => { errorES && setErrorES(false); setMessageErrorSenha(""); }}
                                style={{ display: display.textNovaSenha ? "inline-block" : "none", width: "100%" }}
                                onChange={(e) => setNovaSenha(e.target.value)} />

                            <TextField required
                                type="password"
                                name="confirmarNovaSenha"
                                label="Confirmar Nova Senha"
                                variant="standard"
                                placeholder='Confirme sua nova senha.'
                                fullWidth
                                error={!!errorES}
                                onKeyDown={() => { errorES && setErrorES(false); setMessageErrorSenha(""); }}
                                style={{ display: display.textConfirmarNovaSenha ? "inline-block" : "none", width: "100%" }}
                                //helperText={errorES && "Senha informada não confere!"}
                                onChange={(e) => setConfirmarNovaSenha(e.target.value)} />

                            <Grid container direction="row" spacing={2}>
                                <Grid container size={{ xs: 12, sm: 6 }} >
                                    <Button type='submit' color='primary' variant='contained' disabled={!errorES && isLoading}
                                        fullWidth
                                        style={{ display: display.btnNovaSenha ? "inline-block" : "none", width: "100%", marginTop: "20px" }}
                                        onClick={handleSubmitAlterarSenha}>{isLoading ? "Alterando..." : "Alterar Senha"}
                                    </Button>

                                </Grid>
                                <Grid size={{ xs: 12, sm: 6 }} >
                                    <Button type='submit' color='primary' variant='contained' disabled={isLoading}
                                        fullWidth style={{ display: display.btnNovaSenha ? "inline-block" : "none", width: "100%", marginTop: "20px" }} onClick={mostrarValidacaoCodigo}>Voltar</Button>
                                </Grid>
                                <Grid container size={{ xs: 12, sm: 12 }} >
                                    {
                                        errorES && !isLoading && display.textNovaSenha && display.textConfirmarNovaSenha && display.btnNovaSenha && (<Mensagem type="error" msg={messageErrorSenha} other={count++} />)
                                    }
                                </Grid>
                            </Grid>
                        </Box>
                    </CardContent >
                </Card>
            </VForm>
        </Box >
    )
}

